<template>
<div id="app">
  <!-- <p @click="deletelogin">刪除login</p>
  <p @click="deletehttp">刪除http</p> -->
</div>
</template>

<script>
import common from '@/utils/common.js'
export default {

  name: 'black',

  data () {
    return {

    }
  },

  created () {
    this.checkTokenUrl()
  },
  methods: {

    checkTokenUrl () {
      var token = common.getCookie('utoken')
      if (token == '') {
        if (this.$route.params.isfirst == 'false') {
          var http = common.httpcompany + this.$route.params.states + '&productId=10&redirectUrl=' + encodeURI(common.http + 'company/true/0')

          window.open(http, '_self')
        } else {
          var httpurl = localStorage.getItem('islogin_httpurl') || ''
          if (httpurl == '') {
            httpurl = common.http
          }
          window.location.replace(httpurl)
        }
      } else {
        // localStorage.setItem("is_Token", token)

        var httpurl = localStorage.getItem('islogin_httpurl') || ''

        if (httpurl == '') {
          httpurl = common.http
        }
        window.location.replace(httpurl)
      }
    },

    getQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return ''
    }

  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}

.backgroud {
  width: 1220px;

  background: #ffffff;
  box-shadow: 0px 3px 20px 0px #ececec;
}

.backgroud .left {
  box-shadow: 3px 0px 20px 0px #ececec;
}

.backgroud .right {
  box-shadow: -3px 0px 20px 0px #ececec;
}

.backhover {
  width: 280px;
  height: 168px;
  overflow: hidden;

  background-size: cover;
  background-repeat: no-repeat;
}

.backhover div {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.backhover .subMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
  filter: alpha(opacity=30);
  z-index: 0;
}

.backhover .playIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 6;
  opacity: 0;
  margin: -30px 0 0 -30px;
  width: 60px;
  height: 60px;
  background: url(https://h5.cdn.bjadks.com/website/wsbgt-zt/999-linshi_szk/play-icon1.png) no-repeat;
  filter: alpha(opacity=0);
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
  -ms-transform: scale(1.5);
  transform: scale(1.5);
}

.backhover div:hover .subMask {
  display: block;
  z-index: 5;
}

.backhover div:hover .playIcon {
  z-index: 6;
  opacity: 1;
  filter: alpha(opacity=100);
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.title {
  display: flex;
  margin-top: 15px;
  align-items: center;
}

.title img {
  width: 14px;
  height: 16px;
  margin-right: 5px;
}

.title p {
  flex: 1;
}

.el-carousel__item .carouseldiv {
  color: #475669;

  width: 264px;
  height: 213px;
  margin: 0 auto;
  /* background: #0f0; */
}

.el-carousel__item .carouseltv {
  line-height: 36px;
  font-size: 14px;
  color: #ffffff;
  height: 36px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-carousel__item .carouseltvcheck {
  line-height: 18px;
  font-size: 14px;
  color: #ffffff;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right {
  width: 510px;
  height: 46px;
  background: linear-gradient(rgba(215, 215, 215, 0.4) 0%,
      rgba(248, 248, 248, 0.4) 100%);
}

.more {
  width: auto;
  height: 46px;
  color: #999999;
  display: flex;
  align-items: center;
  line-height: 16px;
  font-size: 14px;
  padding: 0 26px;
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: row-reverse;
}

.bar {
  width: 54px;
  height: 46px;
  color: #000;
  font-weight: 400;
  line-height: 18px;
  font-size: 16px;
  display: flex;
  align-items: center;

  /* justify-content: center; */
  cursor: pointer;
  /* opacity: 0.5;
  transition: opacity 0.5s; */
}

.bar:hover {
  background: #d30000;
  color: #f9f9f9;
}

.active {
  background: #d30000;
  margin-left: -1px;
  color: #f9f9f9;
}

.itemIndex {
  width: 100%;
  height: 31px;
  font-size: 14px;
  padding: 0 15px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  cursor: pointer;
  line-height: 31px;
}

.itemIndex:hover p {
  color: #d30000;
}

/* .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  transform: scale(0.68);
  background-color: #d3dce6;
} */
</style>



// WEBPACK FOOTER //
// src/views/company.vue